<template>
 <div>
    <slot/>
    <el-form label-position="left" :model="formData" :inline="true" ref="ruleForm"  :rules="rules" @validate="handleValidate" @submit.native.prevent="handleSubmit" label-width="120px">
        <el-form-item label="">
            <template slot="label">
               <p></p>
            </template>
            <span class="text-color-normal font12px mr10">通知</span>
            <el-select
                v-model="formData.trigger_action"
                style="width: 110px;margin-right: 10px;"
                @change="changeTriggerAction"
                :disabled="isView"
            >
                <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
            </el-select>
        </el-form-item>
        <el-form-item v-if="formData.trigger_action==='2'">
            <span class="text-color-normal font12px mr10">通知，当天最多通知</span>
        </el-form-item>
        <el-form-item prop="trigger_action_max" v-if="formData.trigger_action==='2'">
                <el-input :value="formData.trigger_action_max" :disabled="isView" size="mini" placeholder="次数" style="width: 150px;"
                          @input="(val)=>changeNum(val)"
                ></el-input>
                <span class="text-color-normal font12px ml10">次</span>
                <el-tooltip placement="top">
                    <div slot="content">
                        以下场景到达检查频次后，若再次触发会重新通知：<br>
                        1、第二日。<br>
                        2、修改托管内容（除了名称外的任何修改）。<br>
                        3、关闭开关，重新打开。<br>
                    </div>
                    <i class="el-icon-question" style="margin-left: 8px;cursor: pointer;"></i>
                </el-tooltip>
        </el-form-item>
        <el-form-item prop="" class="full-w" v-if="formData.trigger_action==='2'">
            <el-radio-group v-model="formData.trigger_action_type" :disabled="isView" class="ml120">
                <el-radio label="1" class="block mb10">
                    按照目标维度分别触发通知次数
                    <el-tooltip placement="top">
                        <div slot="content">
                            <p class="mb10">根据维度筛选对应选择的目标维度分别计算通知次数。</p>
                            <p class="mb10">例如：筛选了两个产品，目标维度也为产品，通知逻辑为【按照目标维度分别触发通知次数】，通知1次，那么两个产品分别最多可以通知一次。若通知逻辑为【统一触发次数】，通知1次，则两个产品一共最多只通知一次。</p>
                            <p>使用小tips：当托管很多内容，又不确定托管内容在什么时候可以触发时，可以添加多个检查频次，然后通知逻辑选择【指定次数（1或2次）】【按照目标维度分别触发通知次数】，这样可以保证今天所有触发托管的内容都可以通知到，又不会频繁收到已经触发过的内容。</p>
                        </div>
                        <i class="el-icon-question" style="margin-left: 8px;cursor: pointer;"></i>
                    </el-tooltip>
                </el-radio>
                <el-radio label="2" class="block mb10">
                    统一触发次数
                    <el-tooltip placement="top">
                        <div slot="content">
                            <p class="mb10">统一计算通知次数，当天通知次数等于设置的次数时，不再运行。</p>
                            <p class="mb10">例如：筛选了两个产品，目标维度也为产品，通知逻辑为【统一触发次数】，通知1次，则两个产品一共最多只通知一次，若在运行检查时只有一个产品触发，托管规则也会停止运行。若希望另一个产品也收到通知，请选择【按照目标维度分别触发通知次数】。</p>
                            <p>使用小tips：当托管很多内容，又不确定托管内容在什么时候可以触发时，可以添加多个检查频次，然后通知逻辑选择【指定次数（1或2次）】【按照目标维度分别触发通知次数】，这样可以保证今天所有触发托管的内容都可以通知到，又不会频繁收到已经触发过的内容。</p>
                        </div>
                        <i class="el-icon-question" style="margin-left: 8px;cursor: pointer;"></i>
                    </el-tooltip>
                </el-radio>
            </el-radio-group>
        </el-form-item>
    </el-form>
 </div>
</template>

<script>
    import FormGroup from '../../formGroup.vue';
    export default {
        name: "NotificationOnly",
        components:{
            FormGroup,
        },
        inject: ['validFormItem','isView'],
        data(){
            let _this = this;
            const validActionMax = (rule, value, callback) =>{
                if(_this.formData.trigger_action !== '2') {
                    callback();
                    return
                }
                if(_this.formData.trigger_action_max===0){
                    callback(new Error('请输入大于0的整数'));
                }else if(!_this.formData.trigger_action_max){
                    callback(new Error('请输入通知次数'));
                }else if(isNaN(_this.formData.trigger_action_max)||+_this.formData.trigger_action_max<=0||(''+_this.formData.trigger_action_max).includes('.')){
                    callback(new Error('请输入大于0的整数'));
                }else if(_this.formData.trigger_action_max<1){
                    callback(new Error('通知最小为1次'));
                }else if(_this.formData.trigger_action_max>100){
                    callback(new Error('最多通知100次'));
                }else{
                    callback();
                }
            };

            return {
                formData:{
                    trigger_action:'1',
                    trigger_action_max:'2',
                    trigger_action_type:'1',
                },
                rules:{
                    trigger_action_max:[
                        { required:true, validator: validActionMax, trigger: 'blur' },
                    ],
                },
                options: [{
                    value: '2',
                    label: '指定次数'
                }, {
                    value: '1',
                    label: '不指定次数'
                }],
            }
        },
        methods:{
            changeTriggerAction(val){
                if(val=='2'){
                    // 选的指定次数
                    if(!this.formData.trigger_action_max){
                        this.formData.trigger_action_max = '2';
                    }
                }
            },
            changeNum(val) {
                const newValue = val.replace(/[^\d]/g, '');
                if (/^[0-9]\d*$/.test(newValue)) {
                    this.formData.trigger_action_max = Number(newValue);
                } else {
                    this.formData.trigger_action_max = '';
                }
            },
            setFormData(data){
                console.log('setFormData',data);
                this.formData.trigger_action = data.trigger_action;
                this.formData.trigger_action_max = data.trigger_action_max;
                if(data.trigger_action=='2'&&data.trigger_action_max>=1&&!data.trigger_action_type){
                    this.formData.trigger_action_type = '2';
                }else{
                    this.formData.trigger_action_type = data.trigger_action_type||'1';
                }
            },
            handleValidate(key, valid, info){
                const data = {
                    trigger_action_max: '操作-触发操作',
                };
                if (!valid) {
                    this.validFormItem(`${data[key]}：${info}`);
                }
            },
            handleSubmit(){
                this.$emit('submit');
            },
            // 获取表单数据
            async validateFn() {
                const valid = await this.$refs.ruleForm.validate();
                if (valid) {
                    return {...this.formData}
                }
            },
        },

    }
</script>

<style scoped>
    .ml120{
        margin-left: 120px;
    }
</style>
